module.exports = __webpack_public_path__ + "components/country-flag/static/nr-632e58e8abcb7b5bb48dccfbcbd5a738.svg";